export const getURLParamByName = (name, url = window.location.search) => {
	if (URLSearchParams) {
		return new URLSearchParams(url).get(name);
	}
	if (URL) {
		return new URL(url).searchParams.get(name);
	}
	const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
	// 获取地址栏的查询参数字符串
	const search = url.indexOf('http') !== -1 ? url.split('?')[1] : url;
	if (search) {
		const r = decodeURIComponent(search.split('#')[0]).substring(1).match(reg);
		if (r) {
			return unescape(r[2]);
		}
	}
	return '';
};

export const loadScript = (url, options = {}) => (new Promise((resolve, reject) => {
	let targetScript = document.querySelector(`script[src="${url}"]`);
	if (!targetScript) {
		targetScript = document.createElement('script');
		targetScript.src = url;
		targetScript.async = !!options.async;
		targetScript.onload = resolve;
		targetScript.onerror = reject;
		document.body && document.body.appendChild(targetScript);
	} else {
		resolve();
	}
}));

export const loadStyle = (url) => (new Promise((resolve, reject) => {
	let targetStyle = document.querySelector(`link[href="${url}"]`);
	if (!targetStyle) {
		targetStyle = document.createElement('link');
		targetStyle.rel = 'stylesheet';
		targetStyle.type = 'text/css';
		targetStyle.href = url;
		targetStyle.onload = resolve;
		targetStyle.onerror = reject;
		document && document.getElementsByTagName('head')[0].appendChild(targetStyle);
	} else {
		resolve();
	}
}));

export const loadScripts = (urls) => urls.map((url) => () => loadScript(url))
		.reduce((prev, cur) => prev.then(() => cur()), Promise.resolve());

export const isMobile = () => {
	let result = false;
	if (window.navigator) {
		const UA = window.navigator.userAgent;
		if (/iPad|iPhone|iPod/.test(UA) && !window.MSStream) {
			result = true; // For iOS
		} else if (UA.match(/Android/i) !== null) {
			result = true; // For Android
		}
	}
	return result;
};

export const getSubscribeLink = (isChannel,
																 {WATCH_SITE_PREFIX, isDomestic, channel, LOC_SERVER, search}) => {
	let suffix = '';
	if (search && getURLParamByName('hidenav', search) === 'true') {
		suffix = 'hidenav=true';
	}
	if (!isChannel) {
		// For league pass page
		return `${WATCH_SITE_PREFIX}streaming-subscriptions${suffix ? `?${suffix}` : ''}`;
	}

	// For nbatv page and channel detail page
	let sku = null;
	if (isDomestic) {
		// Hard code sku for domestic purchase package
		sku = 'LPTV';
	} else {
		const seoName = isDomestic ? 'nbatvliveus' : 'nbatvlive';
		if (channel
				&& channel[seoName]
				&& channel[seoName].detail
				&& channel[seoName].detail.data
				&& channel[seoName].detail.data.bundlePurchases) {
			const {bundlePurchases} = channel[seoName].detail.data;
			for (let i = 0; i < bundlePurchases.length; i += 1) {
				if (/^(LPP|LPE|LPPIN)$/.test(bundlePurchases[i].sku)) {
					sku = bundlePurchases[i].sku;
					break;
				}
			}
		}
	}
	return sku ? `${LOC_SERVER}secure/subscription?sku=B${sku}${suffix ? `&${suffix}` : ''}` : '';
};

export const getVideoInList = (vod = {}, playlist, isNext = false) => {
	let {index} = vod;
	const {id, seoName} = vod;
	let currentVideo = {};
	if (!playlist || playlist.length === 0) {
		return currentVideo;
	}
	if (index === undefined) {
		for (let i = 0, l = playlist.length; i < l; i += 1) {
			if ((id && playlist[i].id && id === playlist[i].id)
					|| (seoName && seoName === playlist[i].seoName)) {
				index = i;
				break;
			}
		}
	}
	if (index !== undefined && index < playlist.length) {
		if (isNext) {
			if (index < (playlist.length - 1)) {
				currentVideo = playlist[index + 1];
			}
		} else if (index < playlist.length) {
			currentVideo = playlist[index];
		}
	}

	return {...currentVideo};
};

export const getTeamLogo = (team, configData) => {
	const {TEAM_LOGO_URL_INTL, TEAM_LOGO_URL, isDomestic} = configData;
	if (team && team.id) {
		if (team.isintl && TEAM_LOGO_URL_INTL) {
			return TEAM_LOGO_URL_INTL.replace('{teamId}', team.id);
		}
		if (TEAM_LOGO_URL) {
			return TEAM_LOGO_URL.replace('{teamId}', team.id).replace('{local}', isDomestic ? 'primary' : 'global');
		}
	}
	return '';
};

// eslint-disable-next-line no-underscore-dangle
window.__NL__ = window.__NL__ || {};
// eslint-disable-next-line no-underscore-dangle
window.__NL__.getTeamLogo = getTeamLogo;
